import type { ReactNode } from 'react';

import styles from './index.module.less';

export interface CapacitySliderRowProps {
  children: ReactNode;
  /** 行尾展示单位，默认 Gi */
  unit?: string;
  className?: string;
}

/** 容量滑条行布局：左侧控件区自适应宽度，右侧单位 */
export function CapacitySliderRow({ children, unit = 'Gi', className }: CapacitySliderRowProps) {
  return (
    <div className={[styles.row, className].filter(Boolean).join(' ')}>
      <div className={styles.control}>{children}</div>
      <div className={styles.unit}>{unit}</div>
    </div>
  );
}
